'use client';

import dynamic from 'next/dynamic';
import type { PrintSignUpModalProps } from '@alltrails/print/components/PrintModal/PrintModal';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

const renderPrintSignUpModal = ({ onCloseRequest, onSuccess }: PrintSignUpModalProps) => (
  <SignUpModal closeModal={onCloseRequest} isOpen onSuccess={onSuccess} trigger="Print Map" upsellTrigger="Print Map" />
);

export default renderPrintSignUpModal;
